import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClientService} from "../../core/services/http-client.service";
import {CommonService} from "../../core/services/common.service";
import {AffiliateService} from "../../core/services/affiliate.service";
import {ToastService} from "../../core/services/toast.service";

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrl: './products.component.css'
})
export class ProductsComponent implements OnInit {

  stats = {
    totalLinks: 0,
    totalProducts: 0,
    totalConversions: 0,
    totalEarnings: 0.0
  };
  customer: any = {};
  affiliateProduct: any;
  private pendingProductId: number | null = null;
  userId: number = this.customer.id;
  userCode: string = 'SD202508';
  generatedLink: string = '';
  isLinkGenerated: boolean = false;
  isGenerating: boolean = false;
  copySuccess: boolean = false;
  statistics: any;

  constructor(private httpService: HttpClientService, private affiliateService: AffiliateService, private common: CommonService,private toast:ToastService) {
    this.customer = this.common.getStorage('customer');
    this.userCode = this.customer.firstName.charAt(0).toUpperCase() + this.customer.lastName.charAt(0).toUpperCase();
  }
  ngOnInit() {
    this.getProductList();
    this.getStatistics();
  }

  public getProductList(): void {
    this.affiliateService.productList(this.customer.id).subscribe({
      next: (res) => {
        this.affiliateProduct = res.response;
        this.stats.totalProducts = res.response?.length || 0;
      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };

  getStatistics() {
    this.affiliateService.getStatistics(this.customer.id).subscribe({
      next: (res) => {
        this.statistics = res.response;
        this.stats.totalLinks = res.response.affiliateLinks?.length || 0;
        this.stats.totalEarnings = (res.response.affiliateEarnings.reduce((sum, r) => sum + (r.amount ?? 0), 0)).toFixed(2);
      },
      error: (err) => {
        console.error("Error loading stats", err);
      }
    });
  };

  saveAffiliateLink(catalogId: number, affiliateCode: string): void {
    const affiliateData = {
      catalogId: catalogId,
      customerId: this.customer.id,
      affiliateCode: affiliateCode,
      linkType: 'PRODUCT'
    };

    this.httpService.post("affiliate/create-affiliate-product", affiliateData).subscribe(
      (response) => {
      },
      (error) => {
        console.error("Error saving affiliate link:", error);
      }
    );
  }

  generateNewLink(productId: number) {
    this.pendingProductId = productId;
    this.isLinkGenerated = false;
    this.generatedLink = '';
    this.copySuccess = false;
    this.isGenerating = false;
    const modal = new (window as any).bootstrap.Modal(document.getElementById('confirmModal'));
    modal.show();
  }

  confirmGeneration() {
    if (this.pendingProductId) {
      this.isGenerating = true;

      setTimeout(() => {
        const smartCode = (this.userCode) + (this.customer.id);
        this.generatedLink = `https://www.smartdukaan.com/product/${this.pendingProductId}?smartCode=${smartCode}`;
        this.saveAffiliateLink(this.pendingProductId!, smartCode);
        this.isLinkGenerated = true;
        this.isGenerating = false;

        const product = this.affiliateProduct?.find((p: any) => p.catalogId === this.pendingProductId);
        if (product) {
          if (!product.affiliateLinks) {
            product.affiliateLinks = [];
          }
          const newLink = {
            type: 'Generated',
            url: this.generatedLink,
            created: new Date().toISOString().split('T')[0]
          };
          product.affiliateLinks.unshift(newLink);
        }
      }, 1500);
    }
  }

  copyToClipboard(text: string) {
    text = "Hi! I have joined as SmartSeller with SmartDukaan. Check out this great deal! \n"+text;
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied:', text);
      this.toast.success("Link Copied to clipboard successfully")
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }
  onModalClose() {
    this.pendingProductId = null;
    this.isLinkGenerated = false;
    this.generatedLink = '';
    this.copySuccess = false;
    this.isGenerating = false;
  }
}
